import {
  ICountryAPIResponseItem,
  ICreatePointOfSaleCategoryAPIRequestBody,
  IGetExchangesAPIResponseItem,
  IGetPointsOfSaleCategoriesAPIResponseItem,
  IUpdatePointOfSaleCategoryAPIRequestBody,
} from 'api/endpoints/general/general.response.interface';
import { TFunction } from 'i18next';

export interface InitialGeneralState {
  ping: boolean;
  setPing: (value: boolean) => void;
  isLoadingSetPing: boolean;
  exchanges: Array<IGetExchangesAPIResponseItem>;
  countries: Array<ICountryAPIResponseItem>;
  associationStates: IAssociationsStates | null;
  // Points of sale categories
  isLoadingPointsOfSaleCategories: boolean;
  pointsOfSaleCategories: Array<IGetPointsOfSaleCategoriesAPIResponseItem>;
  selectCategory: (category: IGetPointsOfSaleCategoriesAPIResponseItem | null) => void;
  categorySelected: IGetPointsOfSaleCategoriesAPIResponseItem | null;
  createCategory: ({
    body,
  }: {
    body: ICreatePointOfSaleCategoryAPIRequestBody;
  }) => Promise<boolean>;
  isLoadingCreateCategory: boolean;
  updateCategory: ({
    body,
  }: {
    body: IUpdatePointOfSaleCategoryAPIRequestBody;
  }) => Promise<boolean>;
  isLoadingUpdateCategory: boolean;
  deleteCategory: ({ categoryId }: { categoryId: string }) => Promise<boolean>;
  isLoadingDeleteCategory: {
    categoryId: string;
    isLoading: boolean;
  };
}

export const pending = 'pending';
export const connected = 'connected';
export const rejected = 'rejected';
export const disconnected = 'disconnected';
export const matching = 'matching';

export type TAssociation = {
  id: string;
  state: string;
};

export interface IAssociationsStates {
  pending: TAssociation;
  connected: TAssociation;
  rejected: TAssociation;
  disconnected: TAssociation;
}

export interface ChildrenProps {
  children: React.ReactNode;
}

export interface IResponseAPI {
  response: Response;
}

export type ITranslate = TFunction<'translation', undefined>;

export type TAlertTypes = 'warning' | 'success' | 'info' | 'error';
